import * as React from "react";
import { useMemo, useState, useCallback } from "react";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { Col } from "common/components";
import { Modal } from "components/bootstrap";
import { Stepper } from "security-app/components/common";
import { useModalContext } from "common/contexts";
import { useCreateAsset, useUpdateAsset } from "security-app/hooks/useAssetsAPI";
import MachineFormButtons from "./MachineFormButtons";
import { validations } from "./utils";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Summary from "./Summary";
const INIT_MACHINE_ASSET = {
  name: "",
  priority: 1,
  // Low priority by default
  category: [],
  imported_from: void 0,
  details: {
    type: "machine",
    owner: "",
    ip_addresses: [],
    hostnames: [],
    mac_addresses: [],
    description: "",
    geo_info: {
      latitude: "",
      longitude: "",
      country_iso_code: "",
      country_name: "",
      city_name: "",
      region: "",
      time_zone: ""
    },
    custom_fields: {}
  }
};
function MachineForm({ asset = INIT_MACHINE_ASSET, show, onClose }) {
  const { t } = useTranslation("enterprise_security_assets");
  const isEditing = useMemo(() => !!(asset == null ? void 0 : asset.id), [asset == null ? void 0 : asset.id]);
  const { setEntity, entity } = useModalContext();
  const [activeStep, setActiveStep] = useState(0);
  const steps = [
    {
      id: "step1",
      title: t("machine_form.step_general_info"),
      valid: true,
      component: /* @__PURE__ */ React.createElement(Step1, null)
    },
    {
      id: "step2",
      title: t("machine_form.step_location"),
      valid: true,
      component: /* @__PURE__ */ React.createElement(Step2, null)
    },
    {
      id: "step3",
      title: t("machine_form.step_custom_fields"),
      valid: true,
      component: /* @__PURE__ */ React.createElement(Step3, null)
    },
    {
      id: "summary",
      title: t("machine_form.step_summary"),
      valid: true,
      component: /* @__PURE__ */ React.createElement(Summary, null)
    }
  ];
  const { createAsset } = useCreateAsset();
  const { updateAsset } = useUpdateAsset();
  const onCancel = useCallback(() => {
    setActiveStep(0);
    onClose();
  }, [onClose]);
  const onSubmit = useCallback(
    async (values) => {
      const newAsset = { ...asset, ...values };
      if (isEditing) {
        await updateAsset({ assetId: newAsset.id, asset: newAsset });
        setEntity({ ...entity, asset: newAsset });
      } else {
        await createAsset({ asset: newAsset });
      }
      onClose();
    },
    [asset, isEditing, onClose, updateAsset, setEntity, entity, createAsset]
  );
  return /* @__PURE__ */ React.createElement(Formik, { onSubmit, initialValues: asset, validate: validations }, /* @__PURE__ */ React.createElement(Modal, { show, onHide: onCancel }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, isEditing ? t("machine_form.title_edit") : t("machine_form.title_new"))), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(Stepper, { steps, activeStep, setActiveStep }), /* @__PURE__ */ React.createElement(Col, null, steps[activeStep].component)), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    MachineFormButtons,
    {
      activeStep,
      steps,
      setActiveStep,
      isEditing,
      onCancel
    }
  ))));
}
export default MachineForm;
